import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";

const PrivacyPolicy = () => {
  return (
    <>
      <Meta title={"Privacy Policy"} />
      <BreadCrumb title="Privacy Policy" />
      <Container class1="policy-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="policy">
              <h2>Privacy Policy</h2>
              <p>
                At <strong>Softech</strong>, we value your privacy and are committed to protecting your 
                personal information. This Privacy Policy explains how we collect, use, disclose, 
                and safeguard your information when you visit our website.
              </p>

              <h3>1. Information We Collect</h3>
              <ul>
                <li>
                  <strong>Personal Information:</strong> Name, email address, phone number, billing address, etc.
                </li>
                <li>
                  <strong>Payment Information:</strong> Credit card details, billing information, and transaction history.
                </li>
                <li>
                  <strong>Technical Information:</strong> IP address, browser type, operating system, and usage data.
                </li>
              </ul>

              <h3>2. How We Use Your Information</h3>
              <ul>
                <li>To process your orders and manage your account.</li>
                <li>To improve our products, services, and customer experience.</li>
                <li>To communicate with you about updates, promotions, and offers.</li>
                <li>To comply with legal obligations and prevent fraud.</li>
              </ul>

              <h3>3. Information Sharing and Disclosure</h3>
              <p>
                We do not sell or rent your personal information to third parties. However, we may 
                share your information with:
              </p>
              <ul>
                <li>Service providers for payment processing and delivery.</li>
                <li>Law enforcement or regulatory authorities if required by law.</li>
                <li>Marketing partners for personalized offers and recommendations.</li>
              </ul>

              <h3>4. Data Security</h3>
              <p>
                We implement industry-standard security measures to protect your personal information 
                from unauthorized access, disclosure, and misuse.
              </p>

              <h3>5. Your Rights</h3>
              <ul>
                <li>You can access, update, or delete your personal information at any time.</li>
                <li>You can opt out of marketing communications.</li>
                <li>You have the right to request a copy of your data.</li>
              </ul>

              <h3>6. Third-Party Links</h3>
              <p>
                Our website may contain links to third-party websites. We are not responsible for the 
                privacy practices or content of these external sites.
              </p>

              <h3>7. Changes to Privacy Policy</h3>
              <p>
                We may update this Privacy Policy periodically. Any changes will be posted on this 
                page with the updated date.
              </p>

              <h3>8. Contact Us</h3>
              <p>
                If you have any questions about this Privacy Policy, please contact us at:  
                <a href="mailto:softechmathikere@gmail.com">softechmathikere@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
